"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_PARAMS_MAPPING = void 0;
exports.MEDIA_PARAMS_MAPPING = {
    print: 'print',
    'orientation:portrait': 'portrait',
    'orientation:landscape': 'landscape',
    'prefers-contrast:more': 'contrast-more',
    'prefers-contrast:less': 'contrast-less',
    'prefers-color-scheme:dark': 'dark',
    'prefers-reduced-motion:no-preference': 'motion-safe',
    'prefers-reduced-motion:reduce': 'motion-reduce',
};
